import { postProfile } from '@auteco/services/snopServices'
import React, { useState } from 'react'
import { Button, Dialog, DialogContent, DialogTitle, TextField } from '@material-ui/core'
import useStyles from './styles'

const DialogCreateProfile = ({ open, onClose, getProfiles }) => {
    const [name, setName] = useState('')

    const classes = useStyles()
    const onCreateProfile = async () => {
        const body = {
            nombre: name
        }
        const { id } = await postProfile({ params: body })
        if (id) {
            setName('')
            getProfiles()
            onClose()
        }
    }
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Crear perfil</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <TextField
                    label='Nombre'
                    variant='outlined'
                    fullWidth
                    onChange={(e) => setName(e.target.value)}
                />
            </DialogContent>
            <Button disabled={name === ''} variant='contained' color='primary' className={classes.createBtn} onClick={onCreateProfile}>Crear</Button>
        </Dialog>
    )
}

export { DialogCreateProfile }